import React from 'react';
import styled from 'styled-components';
import NewArrowLeft from 'crehana-icons/NewArrowLeft';
import ArrowRight from 'crehana-icons/ArrowRight';
import Text from 'crehana-ui/Text';
import {
  grayMain,
  baseMain,
  grayLight,
  secondaryMain,
  secondaryLight,
} from 'crehana-ui/styles/colors';

export const Container = styled.div`
  width: 50%;
  display: flex;
  flex-flow: column;
  flex-shrink: 0;
`;

export const Inner = styled.div`
  padding: 58px 0 80px 0;
  width: fill-available;
  position: relative;
`;

export const HeaderMobile = styled.div`
  z-index: 9999999999999999999999999 !important;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  /* padding: 12px 24px 12px 24px; */
  /* margin-bottom: 24px; */
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.1); */
  background-color: #fff;
`;

export const HeaderTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const FilterButton = styled.button`
  outline: none;
  /* width: 140px; */
  border: 1px solid ${grayMain};
  border-right: unset;
  display: flex;

  justify-content: center;
  align-items: center;
  padding: 14px 16px;
  width: 100%;
  svg {
    margin-right: 8px;
  }
  @media (max-width: 414px) {
    border-left: unset;
  }
`;

export const ButtonTitle = styled.span`
  font-family: Gilroy, Arial, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${baseMain};
  letter-spacing: 0.7px;
  @media (max-width: 320px) {
    font-size: 14px;
  }
`;

export const FixedElements = styled.div<{ top?: boolean; bottom?: boolean }>`
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: white;
  span {
    margin-left: 8px;
  }
  z-index: 20;

  ${props => {
    if (props.top) {
      return `
        top: 0;
        border-bottom: 1px solid ${grayLight};
      `;
    }

    if (props.bottom) {
      return `
        bottom: 0;
        border-top: 1px solid ${grayLight};
      `;
    }
  }}
`;

export const BackButton = ({ onClick }: { onClick?(): void }) => (
  <div style={{ display: 'flex', alignItems: 'center' }} onClick={onClick}>
    <NewArrowLeft size={16} color={secondaryMain} />
  </div>
);

export const Body = styled.div`
  width: 100%;
`;

const ItemInner = ({ className, ...rest }) => (
  <div
    style={{ cursor: 'pointer' }}
    className={`flex justify-between items-center pt-16 pb-16 pl-4 pr-4 ml-20 mr-20 ${className}`}
    {...rest}
  />
);

export const ItemWrapper = styled(ItemInner)`
  &:not(:last-child) {
    border-bottom: 1px solid ${grayLight};
  }
`;

export const FilterItem = ({ onClick, name }) => (
  <ItemWrapper onClick={onClick}>
    <Text type="body2">{name}</Text>
    <ArrowRight color={secondaryLight} size={16} />
  </ItemWrapper>
);
